import {PaginationResult} from "./global.d";

export const emptyListPaginationResult: PaginationResult<unknown> = {
    items: [],
    totalItems: 0,
    page: 0,
    pageSize: 12,
    numPages: 0
}

export const listPaginationLimits = {
    page: 0,
    pageSize: 12,
}
